
import { Options, Vue } from 'vue-class-component';
import Loader from '@/views/Loader.vue';
import MobileNav from '@/components/shared/MobileNav.vue';

@Options({
  components: {
    Loader,
    MobileNav,
  },
})
export default class App extends Vue {
  loading = true;

  async mounted(): Promise<void> {
    await setTimeout(() => {
      this.loading = false;
    }, 3000);
    // this.getNews();
  }
}
